import React, { useRef, useState, useEffect } from 'react'
import { string, node, number, bool, oneOfType, func } from 'prop-types'
import { Select as MuiSelect, InputLabel } from '@material-ui/core'
import { FormControl, FormHelperText } from './Select.style'

export default function Select({
  label,
  name,
  errorMessage,
  children,
  control,
  defaultValue,
  value,
  onChange,
}) {
  const inputLabel = useRef(null)
  const [labelWidth, setLabelWidth] = useState(0)

  useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth)
  }, [])

  return (
    <FormControl variant="outlined">
      <InputLabel ref={inputLabel} htmlFor={name}>
        {label}
      </InputLabel>
      <MuiSelect
        native
        name={name}
        control={control}
        labelWidth={labelWidth}
        defaultValue={defaultValue}
        value={value}
        onChange={onChange}
      >
        {children}
      </MuiSelect>
      {errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
    </FormControl>
  )
}

Select.propTypes = {
  label: string.isRequired,
  name: string.isRequired,
  control: func.isRequired,
  errorMessage: string,
  children: node.isRequired,
  onChange: func.isRequired,
  value: string.isRequired,
  defaultValue: oneOfType([string, number, bool]),
}

Select.defaultProps = {
  errorMessage: '',
  defaultValue: '',
}
